module.exports = __webpack_public_path__ + "img/logos.1375b298.png";